import React, { Component } from 'react'
import { string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions as searchRedirectsActions } from 'services/app-state/search'
import AsdaComHeader from './asda-com'
import PrivacyCentreHeader from './privacy-centre'
import BabyClubHeader from './baby-club'

export class Header extends Component {
  render() {
    return (
      <header className="header">
        {this.renderHeader(this.props.appName)}
      </header>
    )
  }

  renderHeader(appName) {
    switch (appName) {
      case 'asda-com':
        return <AsdaComHeader {...this.props} />
      case 'privacy-centre':
        return <PrivacyCentreHeader {...this.props} />
      case 'baby-club':
        return <BabyClubHeader {...this.props} />
      default:
        return <AsdaComHeader {...this.props} />
    }
  }
}

Header.propTypes = {
  appName: string,
}

Header.defaultProps = {
  appName: 'asda-com',
}

const getAppName = () => {
  const privacyCentre = window.location.pathname.split('/')[1] === 'privacy'
  const babyClub = window.location.pathname.split('/')[1] === 'baby-club'
  if (privacyCentre) {
    return 'privacy-centre'
  }
  if (babyClub) {
    return 'baby-club'
  }
  return 'asda-com'
}

const mapStateToProps = state => ({
  searchRedirects: state.searchRedirects,
  appName: getAppName(),
})

const mapDispatchToProps = dispatch => ({
  searchRedirectsActions: bindActionCreators(searchRedirectsActions, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)



// WEBPACK FOOTER //
// ./components/header/index.js